import script from "./TagDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./TagDetails.vue?vue&type=script&setup=true&lang=js"

import "./TagDetails.vue?vue&type=style&index=0&id=008f132b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008f132b"]])

export default __exports__